import MappingItem from "./DatasetMappingItem";
import { type ColumnMapping } from "./types";
import { Table } from "@mantine/core";

type DatasetMappingProps = {
  items: ColumnMapping[];
  onChange: (items: ColumnMapping[]) => void;
};

export default function DatasetMapping({ items, onChange }: DatasetMappingProps) {
  const updateMappingItem = (newItem: ColumnMapping) => {
    onChange(items.map(item => (item.id === newItem.id ? newItem : item)));
  };

  return (
    <Table>
      <thead>
        <tr style={{ borderBottom: "none" }}>
          <th data-center>Include</th>
          <th colSpan={2}>Column name</th>
          <th>Type</th>
          <th data-center>Status</th>
        </tr>
      </thead>
      <tbody>
        {items.map((item, index) => (
          <MappingItem key={index} item={item} onUpdate={updateMappingItem} />
        ))}
      </tbody>
    </Table>
  );
}
